// extracted by mini-css-extract-plugin
export default {"MainContainer":"CaseTitleform_MainContainer__a0zVS","ComponentContainer":"CaseTitleform_ComponentContainer__zezDV","MultiFormContainer":"CaseTitleform_MultiFormContainer__3RzsS"};